if (typeof StickyAddToCart !== 'function') {
  class StickyAddToCart extends HTMLElement {

    constructor() {

      super();
      const productPage = document.getElementById(this.dataset.id);
      this.hasAttribute('data-append-to') ? document.querySelector(this.dataset.appendTo).appendChild(this) : document.body.appendChild(this);

      const productButton = productPage.querySelector('form[action="/cart/add"] button.product-form__submit[type="submit"]') || productPage.querySelector('form[action="/cart/add"] button.product-form__submit[type="button"]');      
      const mswPopup = document.querySelector('.msw-modal-overlay')

      const stickyBar = this;
      function toggleStickyBarOnScroll() {
        const rect = productButton.getBoundingClientRect();
        const isInViewport = (
          rect.top >= 0 &&
          rect.left >= 0 &&
          (rect.bottom - 80) <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
        const isMobile = window.innerWidth < 728;

        if ((!isMobile && rect.top < 0) || (isMobile && !isInViewport)) {
          stickyBar.classList.add('visible');
        } else {
          stickyBar.classList.remove('visible');
        }
      }
      window.addEventListener('scroll', toggleStickyBarOnScroll);
      toggleStickyBarOnScroll();

      const stickyButton = this.querySelector('button[data-js-atc]');
      stickyButton.addEventListener('click', () => {
        productButton.click();

        if(!mswPopup) {
          stickyButton.classList.add('loading');
          stickyButton.querySelector('.loading__spinner').classList.remove('hidden');
          stickyButton.setAttribute('aria-disabled', true);
        }
      });

      new MutationObserver(() => {
        if (productButton.classList.contains('loading')) {
          stickyButton.classList.add('loading');
          stickyButton.setAttribute('aria-disabled', true);
          stickyButton.querySelector('.loading__spinner').classList.remove('hidden');
        } else {
          stickyButton.classList.remove('loading');
          stickyButton.removeAttribute('aria-disabled');
          stickyButton.querySelector('.loading__spinner').classList.add('hidden');
        }
      }).observe(productButton, {
        attributes: true, childList: false, subtree: false
      })
    }

  }

  if (typeof customElements.get('sticky-add-to-cart') == 'undefined') {
    customElements.define('sticky-add-to-cart', StickyAddToCart);
  }

}
